import { Injectable, Signal } from '@angular/core';
import { IExpenseData, IExpenseModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ExpenseActions, ExpenseSelectors, IExpenseState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class ExpenseStore extends StateAccessService<IExpenseState> {
  readonly state$: Observable<IExpenseState>;

  readonly data$$: Signal<IExpenseData>;
  readonly model$$: Signal<IExpenseModel>;

  constructor() {
    super();

    this.state$ = this.stateFacade.select$(ExpenseSelectors.expenseState);

    this.model$$ = this.stateFacade.selectSignal$(ExpenseSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(ExpenseSelectors.data);
  }

  dispatchExpenseReset() {
    this.stateFacade.dispatch(ExpenseActions.reset());
  }
  dispatchExpenseLoad() {
    this.stateFacade.dispatch(ExpenseActions.load());
  }
  dispatchExpenseLoadSuccess({ model, data }: { model: IExpenseModel; data: IExpenseData }) {
    this.stateFacade.dispatch(ExpenseActions.loadSuccess({ model, data }));
  }
}
